import { defineStore } from 'pinia'
import { ref } from 'vue'
import { setApiContext } from '@/services/apiService'

export const useTenantStore = defineStore('tenant', () => {
  const slug   = ref('')
  const name   = ref('')
  const logo   = ref('')
  const loaded = ref(false)
  const error  = ref(null)

  async function loadTenant (tenantSlug) {
    slug.value   = tenantSlug
    error.value  = null
    loaded.value = false
    // Make slug available to apiService immediately (token set by auth store)
    setApiContext(tenantSlug, null)
    try {
      const res  = await fetch(`/api/${tenantSlug}/config`)
      if (!res.ok) {
        const body = await res.json().catch(() => ({}))
        throw new Error(body.error || `Tenant "${tenantSlug}" not found`)
      }
      const data = await res.json()
      name.value   = data.name
      logo.value   = data.logo || ''
      loaded.value = true
    } catch (e) {
      error.value = e.message
    }
  }

  return { slug, name, logo, loaded, error, loadTenant }
})
